"use strict";
// SPDX-FileCopyrightText: 2024 Red Bee Media Ltd <https://www.redbeemedia.com/>
//
// SPDX-License-Identifier: MIT
Object.defineProperty(exports, "__esModule", { value: true });
exports.OverlayWidgetManager = void 0;
class OverlayWidgetManager {
    constructor({ wrapperElement }) {
        this.widgetManagerInstance = {
            widgets: [],
            wrapperElement,
        };
    }
    addWidget({ url }) {
        if (!url)
            return;
        const widgetId = `widget${this.widgetManagerInstance.widgets.length + 1}`;
        this.widgetManagerInstance.widgets.push({
            id: widgetId,
            url,
        });
        const widgetContainer = document.createElement("iframe");
        widgetContainer.id = widgetId;
        widgetContainer.src = url;
        widgetContainer.style.height = "100%";
        widgetContainer.style.width = "100%";
        widgetContainer.style.left = "0px";
        widgetContainer.style.top = "0px";
        widgetContainer.style.position = "absolute";
        widgetContainer.style.transform = "scale(1.0)";
        widgetContainer.style.transformOrigin = "left top";
        widgetContainer.style.border = "none";
        widgetContainer.setAttribute("scrolling", "no");
        this.widgetManagerInstance.wrapperElement.appendChild(widgetContainer);
    }
    removeWidget({ url }) {
        var _a;
        const widgetIdx = this.widgetManagerInstance.widgets.findIndex((w) => w.url === url);
        const widget = this.widgetManagerInstance.widgets[widgetIdx];
        (_a = document.querySelector(`#${widget.id}`)) === null || _a === void 0 ? void 0 : _a.remove();
        delete this.widgetManagerInstance.widgets[widgetIdx];
    }
    destroy() {
        this.widgetManagerInstance.widgets.forEach((widget) => {
            this.removeWidget({ url: widget.url });
        });
    }
}
exports.OverlayWidgetManager = OverlayWidgetManager;
//# sourceMappingURL=WidgetManager.js.map